import {
  Box,
  Checkbox,
  FormControlLabel,
  SxProps,
  Typography,
} from "@mui/material";
import React from "react";
import { UseAppDispatch } from "redux/store";
import { useSelector } from "react-redux";
import {
  changeBaggageAllowance,
  filterSelector,
  IBaggageAllowance,
} from "redux/filters";

import { useTranslations } from "hooks/useTranslations";
import { IBaggageAllowanceFilter } from "hooks/translations.interfaces";
import { deepCloneObject, pushToDataLayer } from "@thekilroygroup/shared-ui";

export default function BaggageAllowance() {
  const dispatch = UseAppDispatch();
  const { baggageAllowance } = useSelector(filterSelector);

  const { translations } = useTranslations();
  const { included, notIncluded }: IBaggageAllowanceFilter = deepCloneObject(
    translations.filters.filterTypes.filter((obj) => {
      return obj.filter === "baggageAllowance";
    })[0],
  );

  const checkForTouched = (nextBaggageAllowance: IBaggageAllowance) => {
    if (
      nextBaggageAllowance.included === true &&
      nextBaggageAllowance.notIncluded === true
    ) {
      return false;
    }
    return true;
  };

  const handleChangeIncluded = (
    element: React.ChangeEvent<HTMLInputElement>,
    value: boolean,
  ) => {
    const nextBaggageAllowance: IBaggageAllowance =
      deepCloneObject(baggageAllowance);
    nextBaggageAllowance.included = value;
    nextBaggageAllowance.touched = checkForTouched(nextBaggageAllowance);
    trackEvent(`Included - Checked ${value}`);
    dispatch(changeBaggageAllowance(nextBaggageAllowance));
  };

  const handleChangeNotIncluded = (
    element: React.ChangeEvent<HTMLInputElement>,
    value: boolean,
  ) => {
    const nextBaggageAllowance: IBaggageAllowance =
      deepCloneObject(baggageAllowance);
    nextBaggageAllowance.notIncluded = value;
    nextBaggageAllowance.touched = checkForTouched(nextBaggageAllowance);
    trackEvent(`Not included - Checked ${value}`);
    dispatch(changeBaggageAllowance(nextBaggageAllowance));
  };

  const trackEvent = (included: string) => {
    pushToDataLayer(`${included}`, "Filter - Baggage allowance");
  };
  return (
    <>
      <Box sx={sxStyles.checkbox}>
        <FormControlLabel
          control={
            <Checkbox
              onChange={handleChangeIncluded}
              checked={baggageAllowance.included}
            />
          }
          label={
            <>
              <Box sx={sxStyles.labelText}>
                <Typography variant="titleMedium" weight="bold">
                  {included.label}
                </Typography>
              </Box>
              <Typography variant="bodySmall">{included?.note}</Typography>
            </>
          }
          sx={sxStyles.label}
        />
      </Box>
      <Box sx={sxStyles.checkbox}>
        <FormControlLabel
          control={
            <Checkbox
              onChange={handleChangeNotIncluded}
              checked={baggageAllowance.notIncluded}
            />
          }
          label={
            <>
              <Box sx={sxStyles.labelText}>
                <Typography variant="titleMedium" weight="bold">
                  {notIncluded?.label}
                </Typography>
              </Box>
              <Typography variant="bodySmall">{notIncluded?.note}</Typography>
            </>
          }
          sx={sxStyles.label}
        />
      </Box>
    </>
  );
}

const sxStyles: { [key: string]: SxProps } = {
  checkbox: {
    borderBottom: `1px solid`,
    borderBottomColor: "grey.200",
    "&:last-of-type": {
      borderBottom: `0px solid`,
    },
  },
  label: {
    mt: 1,
    mb: 1,
  },
  labelText: {
    "& p": {
      fontWeight: "700",
    },
  },
};
